var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { isNilOrEmpty } from '../../value/isNilOrEmpty';
import { typeOf } from "../../type/typeOf";
/**
 * Immutably reverse an array
 *
 * @category Array
 * @template {T} - The type of the array
 * @param {T[]} array - The array of items
 * @returns {T[]}
 * @example
 * const array = [7, 25, 21];
 *
 * reverse(array)  //=> [21, 25, 7]
 * @docgen_example
 * reverse([7, 25, 21]);
 */
export var reverse = function (array) {
    return typeOf(array) !== 'array' || isNilOrEmpty(array) ? [] : __spreadArray([], array, true).reverse();
};
